import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, Fragment as _Fragment } from "vue"

const _hoisted_1 = { style: {"text-align":"center","margin-bottom":"12px","color":"var(--secondary-100)"} }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "remove-background-edit" }
const _hoisted_4 = { class: "remove-background-edit__settings" }
const _hoisted_5 = { class: "remove-background-edit__tools" }
const _hoisted_6 = { class: "remove-background-edit__tools__item" }
const _hoisted_7 = {
  key: 0,
  class: "remove-background-edit__controllers"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "remove-background-edit__controllers"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "remove-background-edit__tools__item" }
const _hoisted_12 = { class: "remove-background-edit__workarea" }
const _hoisted_13 = { class: "remove-background-edit__workarea__container" }
const _hoisted_14 = { class: "remove-background-edit__canvas__zoom" }
const _hoisted_15 = { class: "remove-background-edit__canvas__image__container" }
const _hoisted_16 = { class: "remove-background-edit__workarea__data" }
const _hoisted_17 = { class: "remove-background-edit__workarea__actions" }

import { onMounted, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';
import { useEventBus } from '@vueuse/core';

import { useCommonStore } from '@/store/common';
import { useServicesStore } from '@/store/services/index';

// import { getBase64Size } from '@/helpers/getBase64Size';
import { removeBase64Prefix } from '@/helpers/removeBase64Prefix';

import { TMode } from '@/types/TMode';

import AddImage from '@/components/common/AddImage/AddImage.vue';
import ImageFinetune from '@/components/common/ImageFinetune/ImageFinetune.vue';
import ResultImage from '@/components/common/ResultImage/ResultImage.vue';
import TimeCounter from '@/components/common/TimeCounter/TimeCounter.vue';

import AiButton from '@/components/UI/AiButton/AiButton.vue';
import AiClearButton from '@/components/UI/AiClearButton/AiClearButton.vue';
import AiCanvas from '@/components/UI/AiCanvas/AiCanvas.vue';
import AiCard from '@/components/UI/AiCard/AiCard.vue';
import AiDropLoader from '@/components/UI/AiDropLoader/AiDropLoader.vue';
import AiTooltip from '@/components/UI/AiTooltip/AiTooltip.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'RemoveBackground',
  setup(__props) {

const busError = useEventBus<string>('toast-error');

const { t } = useI18n();
const baseUrl = process.env.VUE_APP_BASE_URL;

const { isMobile } = storeToRefs(useCommonStore());

const { generateImage } = useServicesStore();

const { imageForActions, sourceBgImage, imageResult, imagePrev } = storeToRefs(useServicesStore());

const generationLoading = ref<boolean>(false);
const imageWidth = ref<number>(0);
const imageHeight = ref<number>(0);
const isEdit = ref<boolean>(false);
const mode = ref<TMode>('erase');
const brushSize = ref<number>(110);
const aiCanvasRef = ref<any>(null);
const activeZoom = ref<number>(1);
const key = ref<number>(0);
const loading = ref<boolean>(false);

// const imageSize = computed(() => getBase64Size(imageForActions.value));

const removeBackgroundFileHandler = async (): Promise<void> => {
  generationLoading.value = true;
  const canvasImage = await aiCanvasRef.value.getBackground();
  imageForActions.value = canvasImage.enlargedBase64src;
  // generateImage({
  //   action: 'remove_background',
  //   image: removeBase64Prefix(imageForActions.value),
  //   params: {},
  // })
  //   .then((res) => {
  imagePrev.value = sourceBgImage.value;
  imageResult.value = imageForActions.value;
  imageForActions.value = sourceBgImage.value;
  //   })
  //   .catch((e) => {
  //     busError.emit(e?.message || t('common.err-gen'));
  //   })
  //   .finally(() => {
  generationLoading.value = false;
  //   });
};

const imageSizeHandler = (): void => {
  if (imageForActions.value !== '') {
    const img = new Image();
    img.onload = () => {
      imageWidth.value = img.width;
      imageHeight.value = img.height;
      key.value += 1;
    };
    img.src = imageForActions.value;
    // const canvas = document.createElement('canvas');
    // const img1 = new Image();
    // img1.onload = async () => {
    //   const imageWidth1 = img1.width;
    //   const imageHeight1 = img1.height;
    //   if (imageWidth1 / imageHeight1 > 1) {
    //     canvas.width = 512;
    //     canvas.height = (512 * imageHeight1) / imageWidth1;
    //   } else {
    //     canvas.height = 512;
    //     canvas.width = (512 * imageWidth1) / imageHeight1;
    //   }

    //   const ctx = canvas.getContext('2d');
    //   if (ctx) {
    //     ctx.drawImage(img1, 0, 0, canvas.width, canvas.height);
    //     sourceBgImage.value = canvas.toDataURL('image/png');
    //     console.log(sourceBgImage.value);
    //     key.value += 1;
    //   }
    // };
    // img1.src = sourceBgImage.value;
  }
};

const editHandler = (image: string): void => {
  imageForActions.value = image;
  isEdit.value = false;
};

const zoomInHandler = (): void => {
  activeZoom.value += 0.1;
};

const zoomOutHandler = (): void => {
  activeZoom.value -= 0.1;
};

const activeZoomSetHandler = (newVal: number): void => {
  activeZoom.value = newVal;
};

const setMode = (modeVal: TMode): void => {
  mode.value = modeVal;
};

const toEditHadler = async (): Promise<void> => {
  const canvasImage = await aiCanvasRef.value.getBackground();
  imageForActions.value = canvasImage.enlargedBase64src;
  isEdit.value = true;
};

onMounted(async () => {
  if (localStorage.getItem('to-remove-bg') === 'true') {
    localStorage.removeItem('to-remove-bg');
    loading.value = true;
    const image = imageForActions.value;
    imageForActions.value = '';
    try {
      const res = await generateImage({
        action: 'remove_background',
        image: removeBase64Prefix(image),
        params: {},
      });
      imageForActions.value = `data:image/png;base64,${res.payload.notTrimmedImage}`;
    } catch (e: any) {
      busError.emit(e?.error || t('common.err-gen'));
    }
    loading.value = false;
    sourceBgImage.value = image;
  }
  imageSizeHandler();
});

watch(imageForActions, () => {
  key.value += 1;
  imageSizeHandler();
  generationLoading.value = false;
});

watch(sourceBgImage, () => {
  imageSizeHandler();
});


return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_slider = _resolveComponent("v-slider")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(imageForActions) === '' && _unref(imageResult) === '')
      ? (_openBlock(), _createBlock(AddImage, { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('menu.remove-bg')), 1),
            _createElementVNode("img", {
              src: `${_unref(baseUrl)}/images/multi-menu/remove-background.png`,
              alt: ""
            }, null, 8, _hoisted_2)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createBlock(AiDropLoader, { key: 1 }))
      : (_unref(imageForActions) !== '' && _unref(imageResult) === '')
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass([{ 'service__container--mobile': _unref(isMobile) }, "service__container remove-background"])
          }, [
            _createElementVNode("div", _hoisted_3, [
              (isEdit.value)
                ? (_openBlock(), _createBlock(ImageFinetune, {
                    key: 0,
                    class: "remove-background-edit__finetune",
                    src: _unref(imageForActions),
                    onReset: _cache[0] || (_cache[0] = ($event: any) => (isEdit.value = false)),
                    onSave: editHandler,
                    actions: ['reset', 'save']
                  }, null, 8, ["src"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.brush-type')), 1),
                          (!_unref(isMobile))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createVNode(AiTooltip, {
                                  "content-class": "remove-background-edit__tooltip",
                                  top: "",
                                  location: "top"
                                }, {
                                  top: _withCtx(() => [
                                    _createVNode(AiClearButton, {
                                      class: _normalizeClass([{ 'remove-background-edit__controller--active': mode.value === 'erase' }, "remove-background-edit__controller"]),
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (setMode('erase')))
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("img", {
                                          src: require('@/assets/icons/editor/removeBg.svg'),
                                          alt: "#"
                                        }, null, 8, _hoisted_8)
                                      ]),
                                      _: 1
                                    }, 8, ["class"])
                                  ]),
                                  content: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('image-editor.erase')), 1),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('image-editor.erase-tooltip-text')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(AiTooltip, {
                                  "content-class": "remove-background-edit__tooltip",
                                  top: "",
                                  location: "top"
                                }, {
                                  top: _withCtx(() => [
                                    _createVNode(AiClearButton, {
                                      class: _normalizeClass([{ 'remove-background-edit__controller--active': mode.value === 'restore' }, "remove-background-edit__controller"]),
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (setMode('restore')))
                                    }, null, 8, ["class"])
                                  ]),
                                  content: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('image-editor.restore-brush')), 1),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('image-editor.restore-tooltip-text')), 1)
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(isMobile))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createVNode(AiClearButton, {
                                  class: _normalizeClass([{ 'remove-background-edit__controller--active': mode.value === 'erase' }, "remove-background-edit__controller"]),
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (setMode('erase')))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("img", {
                                      src: require('@/assets/icons/editor/removeBg.svg'),
                                      alt: "#"
                                    }, null, 8, _hoisted_10)
                                  ]),
                                  _: 1
                                }, 8, ["class"]),
                                _createVNode(AiClearButton, {
                                  class: _normalizeClass([{ 'remove-background-edit__controller--active': mode.value === 'restore' }, "remove-background-edit__controller"]),
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (setMode('restore')))
                                }, null, 8, ["class"])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_v_spacer),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.size')), 1),
                          _createVNode(_component_v_slider, {
                            min: 0,
                            max: 220,
                            modelValue: brushSize.value,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((brushSize).value = $event)),
                            modelModifiers: { number: true },
                            style: {"width":"100px"}
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(AiCard, {
                        radius: 16,
                        class: "remove-background-edit__workarea__card"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(AiClearButton, {
                                class: "remove-background-edit__canvas__zoom__button",
                                "active-zoom": activeZoom.value,
                                onClick: zoomOutHandler
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_inline_svg, {
                                    src: require('@/assets/icons/IconDecrease.svg')
                                  }, null, 8, ["src"])
                                ]),
                                _: 1
                              }, 8, ["active-zoom"]),
                              _createVNode(AiClearButton, {
                                class: "remove-background-edit__canvas__zoom__button",
                                onClick: zoomInHandler
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_inline_svg, {
                                    src: require('@/assets/icons/IconIncrease.svg')
                                  }, null, 8, ["src"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                              (_openBlock(), _createBlock(AiCanvas, {
                                images: [],
                                key: key.value,
                                width: imageWidth.value,
                                height: imageHeight.value,
                                background: _unref(imageForActions),
                                "restore-background": _unref(sourceBgImage),
                                mode: mode.value,
                                ref_key: "aiCanvasRef",
                                ref: aiCanvasRef,
                                "brush-size": brushSize.value,
                                "active-zoom": activeZoom.value,
                                onActiveZoomSet: activeZoomSetHandler
                              }, null, 8, ["width", "height", "background", "restore-background", "mode", "brush-size", "active-zoom"]))
                            ]),
                            (generationLoading.value)
                              ? (_openBlock(), _createBlock(AiDropLoader, { key: 0 }))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_v_spacer),
                            _createElementVNode("div", _hoisted_17, [
                              _createVNode(AiButton, {
                                theme: "dark",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => {imageForActions.value = ''; sourceBgImage.value = ''})
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('services.reset')), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(AiButton, {
                                theme: "dark",
                                onClick: toEditHadler
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('common.edit')), 1)
                                ]),
                                _: 1
                              }),
                              (!_unref(isMobile))
                                ? (_openBlock(), _createBlock(AiButton, {
                                    key: 0,
                                    disabled: generationLoading.value,
                                    theme: "gradient-primary",
                                    class: "remove-background-edit__workarea__button",
                                    onClick: removeBackgroundFileHandler
                                  }, {
                                    default: _withCtx(() => [
                                      (!generationLoading.value)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode(_toDisplayString(_ctx.$t('remove-background.remove-background')), 1)
                                          ], 64))
                                        : (_openBlock(), _createBlock(TimeCounter, { key: 1 }))
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          (_unref(isMobile))
                            ? (_openBlock(), _createBlock(AiButton, {
                                key: 0,
                                theme: "gradient-primary",
                                disabled: generationLoading.value,
                                onClick: removeBackgroundFileHandler,
                                class: "remove-background-edit__settings__button"
                              }, {
                                default: _withCtx(() => [
                                  (!generationLoading.value)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('remove-background.remove-background')), 1)
                                      ], 64))
                                    : (_openBlock(), _createBlock(TimeCounter, { key: 1 }))
                                ]),
                                _: 1
                              }, 8, ["disabled"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ])
                  ], 64))
            ])
          ], 2))
        : (_unref(imageForActions) !== '' && _unref(imageResult) !== '')
          ? (_openBlock(), _createBlock(ResultImage, { key: 3 }))
          : _createCommentVNode("", true)
  ], 64))
}
}

})